import React from 'react';
import styled from 'styled-components';
import SEOHead from '../components/SEOHead';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[4]};
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing[8]};
`;

const Profile: React.FC = () => {
  const pageTitle = 'Profile';
  const pageDescription = 'Manage your profile details.';

  return (
    <>
      <SEOHead title={pageTitle} description={pageDescription} />
      <Container>
        <Title>Profile</Title>
        <p>User profile page coming soon...</p>
      </Container>
    </>
  );
};

export default Profile;
